<template>
    <el-container>
        <el-header>
            <span>Account</span>
        </el-header>
        <el-main class="account-main">
            <div class="account-grid">
                <el-card class="account-card account-profile-card">
                    <div class="account-card-title">Profile</div>
                    <div class="account-email">{{loginInformation.email}}</div>
                    <div class="account-meta">Swift Invoice account</div>
                </el-card>

                <el-card class="account-card account-logo-card">
                    <div class="account-card-title">Company logo</div>
                    <div v-if="haveLogo==1" class="logo-row">
                        <div class="logo-preview">
                            <el-image :src="fileInfo.url">
                                <div slot="placeholder" class="image-slot">
                                    <img style="width: 50px" src="@/static/loading.jpg" alt="">
                                </div>
                            </el-image>
                        </div>
                        <div class="logo-actions">
                            <el-upload
                                    :action=fullRequestURL
                                    :show-file-list="false"
                                    :on-success="handleSuccess"
                                    :before-upload="onBeforeUpload"
                                    :data="uploadData"
                                    accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PBG,.BMP">
                                <el-button type="primary" plain :loading="attachPhotosStatus">Change</el-button>
                            </el-upload>
                            <el-button class="logo-delete-button" @click="handleRemove()"
                                       :loading="deleteLogoStatus" type="text">Delete
                            </el-button>
                        </div>
                    </div>

                    <div v-else class="logo-empty-row">
                        <el-upload
                                :action=fullRequestURL
                                class="avatar-uploader"
                                :show-file-list="false"
                                :on-success="handleSuccess"
                                :before-upload="onBeforeUpload"
                                :data="uploadData"
                                accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PBG,.BMP">
                            <div class="logo-upload-box">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                                <span>{{addLogoText || 'Add logo'}}</span>
                            </div>
                        </el-upload>
                    </div>
                </el-card>

                <el-card class="account-card account-plan-card">
                    <div class="account-card-title">Plan details</div>
                    <div class="plan-status-row">
                        <div class="plan-status">Plan expired on {{formatEnglishDate1(loginInformation.expiresTime* 1000)}} <span class="plan-share-note">Shared with mobile</span></div>
                    </div>
                    <div class="plan-note">Log in again if your subscription status has changed.</div>
                    <el-button class="subscriptionButton" type="success" @click.native.prevent="openSubscriptionPage">
                        Upgrade to Swift Pro
                    </el-button>
                </el-card>
            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {timest} from '@/utils/validate'
    import {formatEnglishDate} from '@/utils/time'
    import {openFastSpringPage} from '@/utils/subscription'
    import {COMPANY_LOGO_FOLDER, getDownloadV2Url, getUploadRemoteKey, prepareFileUpload, takeUploadInnerUUID} from '@/utils/fileUpload'


    export default {
        methods: {
            formatEnglishDate1: formatEnglishDate,

            getCompanyLogoUrl(logoPath, remoteKey) {
                if (null != remoteKey && "" != remoteKey) {
                    return getDownloadV2Url(this.$store.state.requestURL, remoteKey);
                }
                return this.$store.state.requestURL + "/file/download?fileName=" + logoPath + "&email=" + JSON.parse(localStorage.getItem("loginInformation")).objectData.email;
            },
            openSubscriptionPage() {
                openFastSpringPage();
            },
            queryUserInformation() {
                this.$axios.post('get_auth', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        this.loginInformation = response.data.objectData;
                        this.uploadData.email = this.loginInformation.email;

                        let companyLogo = response.data.companyLogo;
                        if (companyLogo != null) {
                            let logoPath = companyLogo.imagePath;
                            let remoteKey = companyLogo.remoteKey;
                            this.fileInfo = {
                                url: this.getCompanyLogoUrl(logoPath, remoteKey),
                                innerUUID: companyLogo.innerUUID
                            };
                            this.haveLogo = 1;
                            localStorage.setItem('logoPath', logoPath);
                        } else {
                            this.haveLogo = 0;
                            this.fileInfo = {};
                            localStorage.setItem('logoPath', "");
                        }


                        let loginInformation2 = JSON.parse(localStorage.getItem("loginInformation"));
                        loginInformation2.objectData.expiresTime = this.loginInformation.expiresTime;
                        localStorage.setItem('loginInformation', JSON.stringify(loginInformation2));
                    }
                }).catch(() => {
                    this.loading = false;
                })
            },
            ///////////////上传///////////////
            handleRemove() {
                let that = this;
                this.deleteLogoStatus = true;
                let companyLogoUUID = that.fileInfo.innerUUID;
                if (companyLogoUUID == null || companyLogoUUID === "") {
                    that.deleteLogoStatus = false;
                    this.$message({
                        type: 'error',
                        message: 'Company logo UUID is missing',
                        duration: 6000
                    });
                    return;
                }
                this.$axios.post('update_company', {
                    params: {
                        companyLogoUUIDArrayKey: "",
                        innerUUID: that.userCompany.innerUUID,
                        accessDate: timest()
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        this.$axios.post('update_company_logo', {
                            params: {
                                innerUUID: companyLogoUUID,
                                syncStatus: 1
                            }
                        }).then(response => {
                            if (response.data.errorCode === 0) {
                                this.$message({
                                    type: 'info',
                                    message: 'delete success',
                                    duration: 6000
                                });
                                that.userCompany.companyLogoUUIDArrayKey = "";
                                localStorage.setItem('userCompany', JSON.stringify(that.userCompany));
                                localStorage.setItem('logoPath', "");
                                that.haveLogo = 0;
                                that.deleteLogoStatus = false;
                                this.fileInfo = {}
                            } else {
                                that.deleteLogoStatus = false;
                                this.$message({
                                    type: 'error',
                                    message: 'delete failed',
                                    duration: 6000
                                });
                            }
                        }).catch(() => {
                            that.deleteLogoStatus = false;
                            this.$message({
                                type: 'error',
                                message: 'delete failed',
                                duration: 6000
                            });
                        })

                    } else {
                        that.deleteLogoStatus = false;
                        this.$message({
                            type: 'error',
                            message: 'delete failed',
                            duration: 6000
                        });
                    }
                }).catch(() => {
                    that.deleteLogoStatus = false;
                    this.$message({
                        type: 'error',
                        message: 'delete failed',
                        duration: 6000
                    });
                })
            },
            onBeforeUpload(file) {
                if (this.haveLogo == 1 && (this.fileInfo.innerUUID == null || this.fileInfo.innerUUID === "")) {
                    this.$message({
                        type: 'error',
                        message: 'Company logo UUID is missing',
                        duration: 6000
                    });
                    return false;
                }
                prepareFileUpload(this.uploadData, this.uploadFileMap, file, COMPANY_LOGO_FOLDER);
                this.uploadData.createDate = timest();
                if (this.haveLogo == 1) {
                    this.uploadData.oldCompanyLogoUUID = this.fileInfo.innerUUID;
                } else {
                    delete this.uploadData.oldCompanyLogoUUID;
                }
                this.addLogoText = "uploading...";
                this.attachPhotosStatus = true;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleSuccess(res, file) {
                this.addLogoText = "";
                this.attachPhotosStatus = false;
                this.$message({
                    type: 'info',
                    message: 'upload success',
                    duration: 6000
                });
                if (file.response.errorCode === 0) {
                    const innerUUID = takeUploadInnerUUID(this.uploadFileMap, file);
                    const remoteKey = getUploadRemoteKey(COMPANY_LOGO_FOLDER, innerUUID);
                    this.haveLogo = 1;
                    let fileList = file.response.uploadFileList;
                    for (let i = 0; i < fileList.length; i++) {
                        this.fileInfo = {
                            name: innerUUID,
                            url: getDownloadV2Url(this.$store.state.requestURL, remoteKey),
                            innerUUID: innerUUID,
                            remoteKey: remoteKey,
                        };
                        localStorage.setItem('logoPath', fileList[i].url);

                    }
                }
            },
        },
        data() {
            return {
                deleteLogoStatus: false,
                loginInformation: {},
                userCompany: {},
                requestURL: "",
                attachPhotosStatus: false,
                uploadData: {
                    email: "",
                    needUpdateCompanyLogo: 1,
                    createDate: timest()
                },
                uploadFileMap: {},
                fileInfo: {},
                fullRequestURL: "",
                haveLogo: 0,
                addLogoText: "",
                loadImgPic: "@/static/loading.svg"
            }
        },
        mounted() {
            this.queryUserInformation();

            this.fullRequestURL = this.$store.state.requestURL + "/file/upload";

            this.userCompany = JSON.parse(localStorage.getItem("userCompany"));
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        font-weight: 700;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        padding: 30px;
    }

    /deep/ .el-input__inner {
        border: none;
    }

    .account-main {
        background: #F7F8FA;
    }

    .account-grid {
        display: grid;
        grid-template-columns: minmax(260px, 1fr) minmax(320px, 1.4fr);
        gap: 20px;
        max-width: 1120px;
    }

    .account-card {
        border: 1px solid #E6E8EF;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(31, 42, 68, 0.07);
    }

    .account-card-title {
        margin-bottom: 18px;
        color: #303133;
        font-size: 18px;
        font-weight: 700;
    }

    .account-profile-card {
        min-height: 170px;
    }

    .account-email {
        color: #1F2D3D;
        font-size: 20px;
        font-weight: 700;
        word-break: break-word;
    }

    .account-meta,
    .plan-note {
        margin-top: 8px;
        color: #7A8494;
        font-size: 14px;
        line-height: 20px;
    }

    .account-logo-card {
        min-height: 170px;
    }

    .logo-row {
        display: flex;
        align-items: center;
        gap: 20px;
    }

    .logo-preview {
        width: 104px;
        height: 104px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 1px solid #E6E8EF;
        border-radius: 8px;
        background: #FFFFFF;
    }

    .logo-preview >>> .el-image {
        width: 100%;
        height: 100%;
    }

    .logo-preview >>> img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
    }

    .logo-actions {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .logo-delete-button {
        color: #F56C6C;
    }

    .logo-empty-row {
        display: flex;
        align-items: center;
    }

    .logo-upload-box {
        width: 160px;
        height: 104px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #409EFF;
        border: 1px dashed #B8C4D6;
        border-radius: 8px;
        background: #F8FBFF;
    }

    .account-plan-card {
        grid-column: 1 / -1;
    }

    .plan-status {
        color: #303133;
        font-size: 18px;
        font-weight: 600;
    }

    .plan-status-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 18px;
    }

    .plan-share-note {
        margin-left: 16px;
        color: #409EFF;
        font-size: 15px;
        font-weight: 600;
        white-space: nowrap;
    }

    .subscriptionButton {
        margin-top: 16px;
        background-color: #0D7DF7;
        border-color: #0D7DF7;
        font-weight: 600;
    }

    .subscriptionButton:focus,
    .subscriptionButton:hover {
        background-color: #0B6FE0;
        border-color: #0B6FE0;
    }

</style>

<style scoped>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    /deep/ .avatar-uploader .el-upload {
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    /deep/ .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    /deep/ .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: auto;
        height: auto;
        line-height: 1;
        text-align: center;
    }

    /deep/ .avatar {
        width: 50px;
        height: 50px;
        display: block;
    }
</style>
